module.exports = __webpack_public_path__ + "img/pad-fill-profile-chart-slide5.45f86d69.gif";